// tslint:disable
/**
 * File manager api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { BaseFile } from '../models';
import { Directory } from '../models';
import { DirectoryCreate } from '../models';
import { FileCreate } from '../models';
import { FileList } from '../models';
import { FileMetadataEdit } from '../models';
import { SrcDest } from '../models';
/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Copy existing file or directory
         * @param {string} diskId 
         * @param {SrcDest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cp(diskId: string, body: SrcDest, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling cp.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling cp.');
            }
            const localVarPath = `/disk/{diskId}/cp`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get files by ids and paths
         * @param {string} diskId 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [paths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        files(diskId: string, ids?: Array<string>, paths?: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling files.');
            }
            const localVarPath = `/disk/{diskId}/files`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (paths) {
                localVarQueryParameter['paths'] = paths.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get files by ids
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        files2(ids?: Array<string>, options: any = {}): RequestArgs {
            const localVarPath = `/disks/files`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of files and directories
         * @param {string} diskId 
         * @param {string} [path] 
         * @param {'file' | 'dir'} [type] 
         * @param {Array<string>} [patterns] 
         * @param {Array<string>} [mimeTypes] 
         * @param {'name' | 'modifiedAt' | 'size'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ls(diskId: string, path?: string, type?: 'file' | 'dir', patterns?: Array<string>, mimeTypes?: Array<string>, sort?: 'name' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling ls.');
            }
            const localVarPath = `/disk/{diskId}/ls`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (patterns) {
                localVarQueryParameter['patterns'] = patterns.join(COLLECTION_FORMATS.csv);
            }

            if (mimeTypes) {
                localVarQueryParameter['mimeTypes'] = mimeTypes.join(COLLECTION_FORMATS.csv);
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new directory
         * @param {string} diskId 
         * @param {DirectoryCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mkdir(diskId: string, body: DirectoryCreate, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling mkdir.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling mkdir.');
            }
            const localVarPath = `/disk/{diskId}/mkdir`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move or rename file or directory
         * @param {string} diskId 
         * @param {SrcDest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mv(diskId: string, body: SrcDest, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling mv.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling mv.');
            }
            const localVarPath = `/disk/{diskId}/mv`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove file or directory
         * @param {string} diskId 
         * @param {Array<string>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rm(diskId: string, body: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling rm.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling rm.');
            }
            const localVarPath = `/disk/{diskId}/rm`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search files recursive in disk by params
         * @param {string} diskId 
         * @param {string} [pattern] 
         * @param {string} [dir] 
         * @param {Array<string>} [mimeTypes] 
         * @param {number} [sizeMin] 
         * @param {number} [sizeMax] 
         * @param {Date} [lastModifiedMin] 
         * @param {Date} [lastModifiedMax] 
         * @param {'name' | 'path' | 'modifiedAt' | 'size'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(diskId: string, pattern?: string, dir?: string, mimeTypes?: Array<string>, sizeMin?: number, sizeMax?: number, lastModifiedMin?: Date, lastModifiedMax?: Date, sort?: 'name' | 'path' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling search.');
            }
            const localVarPath = `/disk/{diskId}/search`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pattern !== undefined) {
                localVarQueryParameter['pattern'] = pattern;
            }

            if (dir !== undefined) {
                localVarQueryParameter['dir'] = dir;
            }

            if (mimeTypes) {
                localVarQueryParameter['mimeTypes'] = mimeTypes.join(COLLECTION_FORMATS.csv);
            }

            if (sizeMin !== undefined) {
                localVarQueryParameter['sizeMin'] = sizeMin;
            }

            if (sizeMax !== undefined) {
                localVarQueryParameter['sizeMax'] = sizeMax;
            }

            if (lastModifiedMin !== undefined) {
                localVarQueryParameter['lastModifiedMin'] = (lastModifiedMin as any).toISOString();
            }

            if (lastModifiedMax !== undefined) {
                localVarQueryParameter['lastModifiedMax'] = (lastModifiedMax as any).toISOString();
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new file or replace old
         * @param {string} diskId 
         * @param {FileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        touch(diskId: string, body: FileCreate, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling touch.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling touch.');
            }
            const localVarPath = `/disk/{diskId}/touch`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit metadata of file or directory
         * @param {string} diskId 
         * @param {FileMetadataEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata(diskId: string, body: FileMetadataEdit, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling updateMetadata.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateMetadata.');
            }
            const localVarPath = `/disk/{diskId}/file-metadata`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload file
         * @param {string} diskId 
         * @param {any} file 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(diskId: string, file: any, path: string, options: any = {}): RequestArgs {
            // verify required parameter 'diskId' is not null or undefined
            if (diskId === null || diskId === undefined) {
                throw new RequiredError('diskId','Required parameter diskId was null or undefined when calling upload.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling upload.');
            }
            // verify required parameter 'path' is not null or undefined
            if (path === null || path === undefined) {
                throw new RequiredError('path','Required parameter path was null or undefined when calling upload.');
            }
            const localVarPath = `/disk/{diskId}/upload`
                .replace(`{${"diskId"}}`, encodeURIComponent(String(diskId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (path !== undefined) { 
                localVarFormParams.append('path', path as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Copy existing file or directory
         * @param {string} diskId 
         * @param {SrcDest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cp(diskId: string, body: SrcDest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseFile> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).cp(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get files by ids and paths
         * @param {string} diskId 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [paths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        files(diskId: string, ids?: Array<string>, paths?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseFile>> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).files(diskId, ids, paths, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get files by ids
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        files2(ids?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseFile>> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).files2(ids, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List of files and directories
         * @param {string} diskId 
         * @param {string} [path] 
         * @param {'file' | 'dir'} [type] 
         * @param {Array<string>} [patterns] 
         * @param {Array<string>} [mimeTypes] 
         * @param {'name' | 'modifiedAt' | 'size'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ls(diskId: string, path?: string, type?: 'file' | 'dir', patterns?: Array<string>, mimeTypes?: Array<string>, sort?: 'name' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileList> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).ls(diskId, path, type, patterns, mimeTypes, sort, order, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create new directory
         * @param {string} diskId 
         * @param {DirectoryCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mkdir(diskId: string, body: DirectoryCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Directory> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).mkdir(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Move or rename file or directory
         * @param {string} diskId 
         * @param {SrcDest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mv(diskId: string, body: SrcDest, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseFile> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).mv(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Remove file or directory
         * @param {string} diskId 
         * @param {Array<string>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rm(diskId: string, body: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).rm(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search files recursive in disk by params
         * @param {string} diskId 
         * @param {string} [pattern] 
         * @param {string} [dir] 
         * @param {Array<string>} [mimeTypes] 
         * @param {number} [sizeMin] 
         * @param {number} [sizeMax] 
         * @param {Date} [lastModifiedMin] 
         * @param {Date} [lastModifiedMax] 
         * @param {'name' | 'path' | 'modifiedAt' | 'size'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(diskId: string, pattern?: string, dir?: string, mimeTypes?: Array<string>, sizeMin?: number, sizeMax?: number, lastModifiedMin?: Date, lastModifiedMax?: Date, sort?: 'name' | 'path' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileList> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).search(diskId, pattern, dir, mimeTypes, sizeMin, sizeMax, lastModifiedMin, lastModifiedMax, sort, order, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create new file or replace old
         * @param {string} diskId 
         * @param {FileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        touch(diskId: string, body: FileCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).touch(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Edit metadata of file or directory
         * @param {string} diskId 
         * @param {FileMetadataEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata(diskId: string, body: FileMetadataEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseFile> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).updateMetadata(diskId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Upload file
         * @param {string} diskId 
         * @param {any} file 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(diskId: string, file: any, path: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = FileApiAxiosParamCreator(configuration).upload(diskId, file, path, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Copy existing file or directory
         * @param {string} diskId 
         * @param {SrcDest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cp(diskId: string, body: SrcDest, options?: any) {
            return FileApiFp(configuration).cp(diskId, body, options)(axios, basePath);
        },
        /**
         * Get files by ids and paths
         * @param {string} diskId 
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [paths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        files(diskId: string, ids?: Array<string>, paths?: Array<string>, options?: any) {
            return FileApiFp(configuration).files(diskId, ids, paths, options)(axios, basePath);
        },
        /**
         * Get files by ids
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        files2(ids?: Array<string>, options?: any) {
            return FileApiFp(configuration).files2(ids, options)(axios, basePath);
        },
        /**
         * List of files and directories
         * @param {string} diskId 
         * @param {string} [path] 
         * @param {'file' | 'dir'} [type] 
         * @param {Array<string>} [patterns] 
         * @param {Array<string>} [mimeTypes] 
         * @param {'name' | 'modifiedAt' | 'size'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ls(diskId: string, path?: string, type?: 'file' | 'dir', patterns?: Array<string>, mimeTypes?: Array<string>, sort?: 'name' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
            return FileApiFp(configuration).ls(diskId, path, type, patterns, mimeTypes, sort, order, offset, limit, options)(axios, basePath);
        },
        /**
         * Create new directory
         * @param {string} diskId 
         * @param {DirectoryCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mkdir(diskId: string, body: DirectoryCreate, options?: any) {
            return FileApiFp(configuration).mkdir(diskId, body, options)(axios, basePath);
        },
        /**
         * Move or rename file or directory
         * @param {string} diskId 
         * @param {SrcDest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mv(diskId: string, body: SrcDest, options?: any) {
            return FileApiFp(configuration).mv(diskId, body, options)(axios, basePath);
        },
        /**
         * Remove file or directory
         * @param {string} diskId 
         * @param {Array<string>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rm(diskId: string, body: Array<string>, options?: any) {
            return FileApiFp(configuration).rm(diskId, body, options)(axios, basePath);
        },
        /**
         * Search files recursive in disk by params
         * @param {string} diskId 
         * @param {string} [pattern] 
         * @param {string} [dir] 
         * @param {Array<string>} [mimeTypes] 
         * @param {number} [sizeMin] 
         * @param {number} [sizeMax] 
         * @param {Date} [lastModifiedMin] 
         * @param {Date} [lastModifiedMax] 
         * @param {'name' | 'path' | 'modifiedAt' | 'size'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(diskId: string, pattern?: string, dir?: string, mimeTypes?: Array<string>, sizeMin?: number, sizeMax?: number, lastModifiedMin?: Date, lastModifiedMax?: Date, sort?: 'name' | 'path' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
            return FileApiFp(configuration).search(diskId, pattern, dir, mimeTypes, sizeMin, sizeMax, lastModifiedMin, lastModifiedMax, sort, order, offset, limit, options)(axios, basePath);
        },
        /**
         * Create new file or replace old
         * @param {string} diskId 
         * @param {FileCreate} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        touch(diskId: string, body: FileCreate, options?: any) {
            return FileApiFp(configuration).touch(diskId, body, options)(axios, basePath);
        },
        /**
         * Edit metadata of file or directory
         * @param {string} diskId 
         * @param {FileMetadataEdit} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata(diskId: string, body: FileMetadataEdit, options?: any) {
            return FileApiFp(configuration).updateMetadata(diskId, body, options)(axios, basePath);
        },
        /**
         * Upload file
         * @param {string} diskId 
         * @param {any} file 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(diskId: string, file: any, path: string, options?: any) {
            return FileApiFp(configuration).upload(diskId, file, path, options)(axios, basePath);
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * Copy existing file or directory
     * @param {string} diskId 
     * @param {SrcDest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public cp(diskId: string, body: SrcDest, options?: any) {
        return FileApiFp(this.configuration).cp(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * Get files by ids and paths
     * @param {string} diskId 
     * @param {Array<string>} [ids] 
     * @param {Array<string>} [paths] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public files(diskId: string, ids?: Array<string>, paths?: Array<string>, options?: any) {
        return FileApiFp(this.configuration).files(diskId, ids, paths, options)(this.axios, this.basePath);
    }

    /**
     * Get files by ids
     * @param {Array<string>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public files2(ids?: Array<string>, options?: any) {
        return FileApiFp(this.configuration).files2(ids, options)(this.axios, this.basePath);
    }

    /**
     * List of files and directories
     * @param {string} diskId 
     * @param {string} [path] 
     * @param {'file' | 'dir'} [type] 
     * @param {Array<string>} [patterns] 
     * @param {Array<string>} [mimeTypes] 
     * @param {'name' | 'modifiedAt' | 'size'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public ls(diskId: string, path?: string, type?: 'file' | 'dir', patterns?: Array<string>, mimeTypes?: Array<string>, sort?: 'name' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
        return FileApiFp(this.configuration).ls(diskId, path, type, patterns, mimeTypes, sort, order, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * Create new directory
     * @param {string} diskId 
     * @param {DirectoryCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public mkdir(diskId: string, body: DirectoryCreate, options?: any) {
        return FileApiFp(this.configuration).mkdir(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * Move or rename file or directory
     * @param {string} diskId 
     * @param {SrcDest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public mv(diskId: string, body: SrcDest, options?: any) {
        return FileApiFp(this.configuration).mv(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * Remove file or directory
     * @param {string} diskId 
     * @param {Array<string>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public rm(diskId: string, body: Array<string>, options?: any) {
        return FileApiFp(this.configuration).rm(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * Search files recursive in disk by params
     * @param {string} diskId 
     * @param {string} [pattern] 
     * @param {string} [dir] 
     * @param {Array<string>} [mimeTypes] 
     * @param {number} [sizeMin] 
     * @param {number} [sizeMax] 
     * @param {Date} [lastModifiedMin] 
     * @param {Date} [lastModifiedMax] 
     * @param {'name' | 'path' | 'modifiedAt' | 'size'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public search(diskId: string, pattern?: string, dir?: string, mimeTypes?: Array<string>, sizeMin?: number, sizeMax?: number, lastModifiedMin?: Date, lastModifiedMax?: Date, sort?: 'name' | 'path' | 'modifiedAt' | 'size', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
        return FileApiFp(this.configuration).search(diskId, pattern, dir, mimeTypes, sizeMin, sizeMax, lastModifiedMin, lastModifiedMax, sort, order, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * Create new file or replace old
     * @param {string} diskId 
     * @param {FileCreate} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public touch(diskId: string, body: FileCreate, options?: any) {
        return FileApiFp(this.configuration).touch(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * Edit metadata of file or directory
     * @param {string} diskId 
     * @param {FileMetadataEdit} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public updateMetadata(diskId: string, body: FileMetadataEdit, options?: any) {
        return FileApiFp(this.configuration).updateMetadata(diskId, body, options)(this.axios, this.basePath);
    }

    /**
     * Upload file
     * @param {string} diskId 
     * @param {any} file 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public upload(diskId: string, file: any, path: string, options?: any) {
        return FileApiFp(this.configuration).upload(diskId, file, path, options)(this.axios, this.basePath);
    }

}
